import { storeCreator } from '@/utils/store/store.utils';

export enum TerminationSteps {
  SET_TERMINATION_DATE = 'TERMINATION',
  SET_TERMINATION_PARAMS = 'TERMINATION_SUCCESS',
}

interface State {
  modalVisible: boolean;
  planId?: string;
  planName?: string;
  isHsaAccount?: boolean;
  step: TerminationSteps;
  terminationStatus?: string;
  terminationDate?: string;
  editMode?: boolean;
  hsaPlanStartDate?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalAction?: (value?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSetAdditionalAction: (value?: (value?: any) => void) => void;
  handleSetIsHsaAccount: (value?: boolean) => void;
  handleSetEditMode: (value?: boolean) => void;
  handleSetTerminationDate: (value?: string) => void;
  handleSetPlanName: (value?: string) => void;
  handleSetPlanId: (value?: string) => void;
  handleSetStep: (value: TerminationSteps) => void;
  handleChangeVisibility: (value: boolean) => void;
  handleSetTerminationStatus: (value?: string) => void;
  handleSetHsaPlanStartDate: (value?: string) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  modalVisible: false,
  step: TerminationSteps.SET_TERMINATION_DATE,
  terminationDate: undefined,
  planId: undefined,
  planName: undefined,
  additionalAction: undefined,
  editMode: false,
  terminationStatus: undefined,
  isHsaAccount: false,
  hsaPlanStartDate: undefined,

  handleChangeVisibility: (value) => set((state) => ({
    ...state,
    modalVisible: value,
  })),

  handleSetStep: (value) => set((state) => ({
    ...state,
    step: value,
  })),

  handleSetTerminationDate: (value) => set((state) => ({
    ...state,
    terminationDate: value,
  })),

  handleSetPlanId: (value) => set((state) => ({
    ...state,
    planId: value,
  })),

  handleSetPlanName: (value) => set((state) => ({
    ...state,
    planName: value,
  })),

  handleSetAdditionalAction: (value) => set((state) => ({
    ...state,
    additionalAction: value,
  })),

  handleSetEditMode: (value) => set((state) => ({
    ...state,
    editMode: value,
  })),

  handleSetTerminationStatus: (value) => set((state) => ({
    ...state,
    terminationStatus: value,
  })),

  handleSetIsHsaAccount: (value) => set((state) => ({
    ...state,
    isHsaAccount: value,
  })),

  handleSetHsaPlanStartDate: (value) => set((state) => ({
    ...state,
    hsaPlanStartDate: value,
  })),

  handleReset: () => set((state) => ({
    ...state,
    step: TerminationSteps.SET_TERMINATION_DATE,
    terminationDate: undefined,
    planId: undefined,
    planName: undefined,
    modalVisible: false,
    additionalAction: undefined,
    editMode: false,
    terminationStatus: undefined,
    isHsaAccount: false,
    hsaPlanStartDate: undefined,
  })),
}));